export default "__VITE_ASSET__CyTp2xh4__"